import {
  DEFAULT_K8_REPORT_UNIT_SECTION,
  K8_REPORT_UNIT_SECTION,
} from 'pages/K8Report/flag.on/constants'

const CORE_TOOLTIPS = {
  classes: 'Classes in this school that report K-8 core unit progress.',
  grade: 'Grade level for each class.',
  progressCore: 'Lessons marked done out of lessons available for units 1–4.',
  progress: 'Lessons marked done out of total lessons available.',
  lastLesson: 'The last lesson marked done for the class.',
  markedDone: 'When that lesson was marked done.',
}

export const UNIT_RANGE_OPTIONS = {
  CORE: 'Units 1-4',
  BHU: 'Recognizing Bullying and Harassment Unit',
}

/** Display label for Digital Well-Being curriculum (school summary table + class drawer). */
export const DIGITAL_WELL_BEING_UNIT_LABEL = 'Digital Well-Being Unit'

export const selectSchoolSummaryReportTableData = (
  state,
  selectedUnitRange = UNIT_RANGE_OPTIONS.CORE,
  k8ReportUnitSection = DEFAULT_K8_REPORT_UNIT_SECTION,
) => {
  const { reportsManager } = state
  const { k8Reports, selectedSite } = reportsManager || {}
  const siteData = k8Reports?.[selectedSite]
  const curriculumData = siteData?.curriculum || []
  const usersById = siteData?.usersById || {}

  const effectiveUnitSection =
    k8ReportUnitSection || DEFAULT_K8_REPORT_UNIT_SECTION
  const isSpecializedTab =
    effectiveUnitSection === K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS

  let curriculumFilter
  if (isSpecializedTab) {
    curriculumFilter = 'DWB'
  } else if (selectedUnitRange === UNIT_RANGE_OPTIONS.CORE) {
    curriculumFilter = 'Core'
  } else {
    curriculumFilter = 'BHU'
  }

  const filteredClasses = curriculumData.filter(
    cls => cls.curriculum === curriculumFilter,
  )

  const allClasses = filteredClasses.map(cls => {
    const user = usersById[cls.user_id] || {}
    const lastLessonNum = cls.last_lesson_done_lesson_number
    return {
      classInstance: cls.instance,
      teacherLastName: user.last_name || '',
      teacherFirstName: user.first_name || '',
      className: cls.class_name || '',
      gradeName: cls.grade || '',
      lessonsCompleted: cls.lessons_done || 0,
      lessonsCompletedCore: cls.lessons_done || 0,
      lessonCount: cls.total_lessons || 0,
      lessonCountCore: cls.total_lessons || 0,
      hasCompletedLessonLastPeriod: cls.any_lesson_completed_in_period || false,
      lastLessonCompleted: lastLessonNum ? `lesson ${lastLessonNum}` : '',
      lastLessonCompletedParent: '',
      lastLessonCompletedTitle: cls.last_lesson_done_title || '',
      lastLessonCompletedDate: cls.last_lesson_done_on || '',
    }
  })

  const numClassesMarkedLastPeriod = allClasses.filter(
    c => c.hasCompletedLessonLastPeriod,
  ).length
  const numClassesNotMarkedLesson = allClasses.filter(
    c => c.lessonsCompleted === 0,
  ).length

  return {
    activityFilterLabel: 'Recent Activity',
    classes: allClasses,
    classesTooltip: CORE_TOOLTIPS.classes,
    displayUnit5Column: false,
    gradeTooltip: CORE_TOOLTIPS.grade,
    lastLessonTooltip: CORE_TOOLTIPS.lastLesson,
    markedDoneTooltip: CORE_TOOLTIPS.markedDone,
    numClassesMarkedLastPeriod,
    numClassesNotMarkedLesson,
    progressCoreTooltip: CORE_TOOLTIPS.progressCore,
    progressTooltip: CORE_TOOLTIPS.progress,
    title: isSpecializedTab
      ? 'Specialized Unit Progress by Class'
      : 'Core Unit Progress by Class',
    totalClassesCount: allClasses.length,
    unitRangeLabel: isSpecializedTab
      ? DIGITAL_WELL_BEING_UNIT_LABEL
      : selectedUnitRange,
    unitRangeOptions: isSpecializedTab
      ? [DIGITAL_WELL_BEING_UNIT_LABEL]
      : [UNIT_RANGE_OPTIONS.CORE, UNIT_RANGE_OPTIONS.BHU],
  }
}
